module.exports = __webpack_public_path__ + "static/shape_two-67f15a515cb5175dd7d117c72659b25d.png";